var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"d-flex flex-column justify-center align-center fill-height grey lighten-4"},[_c('AsiLoginForm',{staticClass:"login-form",attrs:{"max-width":"30rem"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }